"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SpellcheckTag;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactDom = require("react-dom");
var _context = require("../context");
var _tinymce = _interopRequireDefault(require("tinymce/tinymce"));
var _constants = require("../constants");
var _throttle = _interopRequireDefault(require("lodash/throttle"));
var _excluded = ["startIndex", "endIndex"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var $ = _tinymce["default"].dom.DomQuery;
var textNodeFilter = function textNodeFilter(textNode) {
  return !$(textNode).parents('table, a, .webmail_signature, .webmail_quote').length;
};
var NOT_WORD_REGEXP = /\W/;
var checkCorrectionInRange = function checkCorrectionInRange(textContent, correction) {
  var startIndex = correction.startIndex,
    endIndex = correction.endIndex,
    origText = correction.origText;
  if (textContent.length < endIndex) return false;
  if (textContent.slice(startIndex, endIndex) !== origText) return false;
  if (textContent[endIndex] && !textContent[endIndex].match(NOT_WORD_REGEXP)) {
    return false;
  }
  return true;
};
function SpellcheckTag(_ref) {
  var onSpellCheck = _ref.onSpellCheck;
  var editor = (0, _context.useEditor)();
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selection = _useState2[0],
    setSelection = _useState2[1];
  var _useState3 = (0, _react.useState)(new Map()),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    textNodeToCorrections = _useState4[0],
    setTextNodeToCorrections = _useState4[1];
  var spellCheckRef = (0, _react.useRef)(onSpellCheck);
  var _useMemo = (0, _react.useMemo)(function () {
      if (!selection) return [null, null];
      var offset = selection.anchorOffset,
        node = selection.anchorNode;
      if (!textNodeToCorrections.has(node)) return [null, null];
      var textContent = node.textContent;
      var corrections = textNodeToCorrections.get(node).filter(function (item) {
        return textContent.length >= item.endIndex && textContent.slice(item.startIndex, item.endIndex) === item.origText;
      });
      var correction = corrections.find(function (item) {
        var startIndex = item.startIndex,
          endIndex = item.endIndex;
        return offset > startIndex && offset <= endIndex;
      });
      if (!correction) return [null, null];
      var startIndex = correction.startIndex,
        endIndex = correction.endIndex;
      var editRange = document.createRange();
      editRange.setStart(node, startIndex);
      editRange.setEnd(node, endIndex);
      return [correction, editRange.getBoundingClientRect()];
    }, [selection, textNodeToCorrections]),
    _useMemo2 = (0, _slicedToArray2["default"])(_useMemo, 2),
    activeCorrection = _useMemo2[0],
    anchorElement = _useMemo2[1];
  (0, _react.useEffect)(function () {
    spellCheckRef.current = onSpellCheck;
  }, [onSpellCheck]);
  (0, _react.useEffect)(function () {
    var handleChangeSelection = function handleChangeSelection(e) {
      if (!editor.selection || !editor.selection.isCollapsed()) {
        return setSelection(null);
      }
      var sel = editor.selection.getSel();
      setSelection({
        anchorNode: sel === null || sel === void 0 ? void 0 : sel.anchorNode,
        anchorOffset: sel === null || sel === void 0 ? void 0 : sel.anchorOffset
      });
    };
    editor.on('SelectionChange NodeChange', handleChangeSelection);
    return function () {
      editor.off('SelectionChange NodeChange', handleChangeSelection);
    };
  }, [editor]);
  var mutatedTextNodesRef = (0, _react.useRef)(new Set());
  var replaceTextNodeRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var body = editor.getBody();
    var throttledSpellCheck = (0, _throttle["default"])(function () {
      if (!mutatedTextNodesRef.current.size) return;
      var textNodes = (0, _toConsumableArray2["default"])(mutatedTextNodesRef.current).filter(function (item) {
        return item.textContent.trim().length;
      });
      var contents = textNodes.map(function (item) {
        return item.textContent;
      });
      var formatedContents = (0, _toConsumableArray2["default"])(new Set(contents));
      if (!formatedContents.length) return;
      spellCheckRef.current(formatedContents).then(function (results) {
        if (!results.length) return;
        setTextNodeToCorrections(function (textNodeToCorrections) {
          contents.filter(function (item, index) {
            return textNodes[index].isConnected;
          }).forEach(function (item, index) {
            var contentIndex = formatedContents.indexOf(item);
            !!~contentIndex && results[contentIndex] && textNodes[index] && textNodeToCorrections.set(textNodes[index], results[contentIndex].corrections);
          });
          (0, _toConsumableArray2["default"])(textNodeToCorrections.keys()).forEach(function (textNode) {
            if (!textNode.isConnected) {
              textNodeToCorrections["delete"](textNode);
            }
          });
          return new Map(textNodeToCorrections);
        });
      });
      mutatedTextNodesRef.current.clear();
    }, 2000, {
      leading: false,
      trailing: true
    });
    var mutationObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        // multiple changes for the same mutation
        var mutation = mutations[i];
        if (mutation.type === 'characterData') {
          if (replaceTextNodeRef.current === mutation.target) {
            replaceTextNodeRef.current = null;
            continue;
          }
          textNodeFilter(mutation.target) && mutation.target.isConnected && mutatedTextNodesRef.current.add(mutation.target);
        } else if (mutation.type === 'childList') {
          var addedNodes = mutation.addedNodes,
            previousSibling = mutation.previousSibling,
            nextSibling = mutation.nextSibling;
          var nodes = [].concat((0, _toConsumableArray2["default"])(addedNodes), [previousSibling, nextSibling]);
          if (nodes.length) {
            nodes.filter(Boolean).filter(function (item) {
              return item.nodeType === Node.TEXT_NODE;
            }).forEach(function (item) {
              textNodeFilter(item) && item.isConnected && mutatedTextNodesRef.current.add(item);
            });
          }
        }
        throttledSpellCheck();
      }
    });
    mutationObserver.observe(body, {
      attributes: false,
      childList: true,
      characterData: true,
      subtree: true
    });
    return function () {
      mutationObserver.disconnect();
    };
  }, [editor]);
  (0, _react.useEffect)(function () {
    var handleFocus = function handleFocus() {
      var body = editor.getBody();
      var $textNodes = $(body).find('*').contents().filter(function (index, item) {
        return item.nodeType === Node.TEXT_NODE && textNodeFilter(item) && item.textContent.trim().length;
      });
      var textNodes = [];
      $textNodes.each(function (index, item) {
        return textNodes.push(item);
      });
      var contents = textNodes.map(function (item) {
        return item.textContent;
      });
      var formatedContents = (0, _toConsumableArray2["default"])(new Set(contents));
      var textNodeToCorrections = new Map();
      if (!formatedContents.length) return;
      spellCheckRef.current(formatedContents).then(function (results) {
        if (!results.length) return;
        contents.filter(function (item, index) {
          return textNodes[index].isConnected;
        }).forEach(function (item, index) {
          var contentIndex = formatedContents.indexOf(item);
          !!~contentIndex && results[contentIndex] && textNodes[index] && textNodeToCorrections.set(textNodes[index], results[contentIndex].corrections);
        });
        setTextNodeToCorrections(textNodeToCorrections);
      });
    };
    editor.on('Undo Redo', handleFocus);
    if (editor.hasFocus()) {
      handleFocus();
    } else {
      editor.once('focus', handleFocus);
      return function () {
        editor.off('focus', handleFocus);
      };
    }
  }, [editor]);
  var handleReplaceText = function handleReplaceText(event, correction) {
    event.preventDefault();
    var anchorNode = selection.anchorNode;
    var startIndex = correction.startIndex,
      endIndex = correction.endIndex,
      CorText = correction.CorText;
    replaceTextNodeRef.current = anchorNode;
    anchorNode.replaceData(startIndex, endIndex - startIndex, CorText);
    setTextNodeToCorrections(function (textNodeToCorrections) {
      var corrections = textNodeToCorrections.get(anchorNode);
      if (!corrections) return textNodeToCorrections;
      var correctionIndex = corrections.indexOf(correction);
      if (!~correctionIndex) return textNodeToCorrections;
      var offset = endIndex - startIndex - CorText.length;
      var newCorrections = corrections.map(function (item, index) {
        if (index < correctionIndex) return item;
        if (index === correctionIndex) return null;
        var startIndex = item.startIndex,
          endIndex = item.endIndex,
          rest = (0, _objectWithoutProperties2["default"])(item, _excluded);
        return _objectSpread({
          startIndex: startIndex - offset,
          endIndex: endIndex - offset
        }, rest);
      }).filter(Boolean);
      textNodeToCorrections.set(anchorNode, newCorrections);
      return new Map(textNodeToCorrections);
    });
    editor.fire('change');
  };
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _toConsumableArray2["default"])(textNodeToCorrections.keys()).filter(Boolean).filter(function (item) {
    return item.isConnected;
  }).map(function (textNode, index) {
    var corrections = textNodeToCorrections.get(textNode);
    var textContent = textNode.textContent;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: index
    }, corrections.filter(function (item) {
      return checkCorrectionInRange(textContent, item);
    }).map(function (item, index) {
      var range = document.createRange();
      range.setStart(textNode, item.startIndex);
      range.setEnd(textNode, item.endIndex);
      var _range$getBoundingCli = range.getBoundingClientRect(),
        left = _range$getBoundingCli.left,
        top = _range$getBoundingCli.top,
        width = _range$getBoundingCli.width,
        height = _range$getBoundingCli.height;
      var spellCheckType = item.type;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])("absolute pointer-events-none", {
          'grammar-error': spellCheckType === _constants.SpellCheckTypes.GRAMMAR,
          'spell-error': spellCheckType === _constants.SpellCheckTypes.SPELL
        }),
        key: index,
        style: {
          top: top,
          left: left,
          width: width,
          height: height
        }
      });
    }));
  }), !!anchorElement && /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute",
    style: {
      zIndex: 100,
      transform: "translate3d(".concat(anchorElement.left, "px, ").concat(anchorElement.bottom, "px, 0px)")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "spellcheck-button-container",
    className: "bg-app dark:bg-card hover:bg-secondary"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    id: "spellcheck-button",
    className: "text-gray-dark",
    onMouseDown: function onMouseDown(event) {
      return handleReplaceText(event, activeCorrection);
    }
  }, activeCorrection.CorText)))), editor.getContainer());
}
//# sourceMappingURL=SpellcheckTagContainer.js.map